import React, { useState, useEffect, useMemo } from 'react';
import { useHistory, useParams } from "react-router-dom";

import T, { Translate } from '../../i18n/i18n';
import { HeaderRow, ButtonBack, Title, ButtonIcon, Button, ConfirmMessage, UserProfilePage, UserHeader, UserInfo, UserLetter, UserNamesGroup, UserName, UserLabel, UserDataColumn, UserDataGeneralGroup, UserDataField, UserValue, Checked, Unchecked, ContactIcon, SectionTitle, UserAvailable, UserAvailableObs, UserTabs, UserTab, UserLabelLine, UserDataGroupTags, Tag, UserDataTagsRow, UserDataNotValue, None, Label, Select, Input} from './UserProfile.styles';
import { getUserProfile, requestFriendship, acceptFriendRequest, cancelFriendRequest, blockUser, unblockUser, denouceUser } from '../../../services/friends';
import { ConvertToTimeDisplay } from '../../../services/dates';
import { HEXtoBlackOrWhite } from '../../../services/colors';
import { profilesActions, rtcBufferActions } from '../../../redux/actions';
import { useDispatch } from 'react-redux';

const reasons = ["boring", "span", "content", "racism", "disrespect", "other"];

export default () => {

    const history = useHistory();
    const params = useParams();
    const dispatch = useDispatch();
    
    const [userdata, setUserdata] = useState(null);
    const [tabSelected, setTabSelected] = useState('player');
    const [showExtraActions, setShowExtraActions] = useState(false);
    const [showConfirmAction, setShowConfirmAction] = useState(false);
    const [showDenounceForm, setShowDenounceForm] = useState(false);
    const [denounceReason, setDenounceReason] = useState("");
    const [denounceNote, setDenounceNote] = useState("");

    const handleBack = () => {
        history.goBack();
    };

    const handleAddAsFriend = async () => {
        let resp = await requestFriendship(params.id);
        if (resp && resp.status === 'ok') {
            dispatch(profilesActions.setMessage(Translate("userprofile.addedSuccessful"), "ok"));
            dispatch(profilesActions.loadFriends(resp.payload.friends ?? [], resp.payload.invited ?? [], resp.payload.pending ?? []));
            dispatch(rtcBufferActions.pushOutputBuffer({
                type: 'frienListUpdate',
                to: userdata.email,
                data: ""
            }));
            dispatch(profilesActions.setUpdateFriendlist());
            history.goBack();
        }
    }

    const handleAcceptRequest = async () => {
        let res = await acceptFriendRequest(params.id);
        if (res.status === 'ok') {
            dispatch(profilesActions.setMessage(Translate("friends.accepted"),"ok"));
            dispatch(profilesActions.loadFriends(
                res.payload.friends ?? [],
                res.payload.invited ?? [],
                res.payload.pending ?? [],
            ));
            dispatch(rtcBufferActions.pushOutputBuffer({
                type: 'frienListUpdate',
                to: userdata.email,
                data: ""
            }));
            dispatch(profilesActions.setUpdateFriendlist());
        } else {
            dispatch(profilesActions.setMessage(res.message,"error"));
        }
        history.goBack();
    }

    const handleCancelRequest = async (type) => {
        let res = await cancelFriendRequest(params.id);
        if (res.status === 'ok') {
            dispatch(profilesActions.setMessage(Translate(`friends.${type}`),"ok"));
            dispatch(profilesActions.loadFriends(
                res.payload.friends ?? [],
                res.payload.invited ?? [],
                res.payload.pending ?? [],
            ));
            dispatch(rtcBufferActions.pushOutputBuffer({
                type: 'frienListUpdate',
                to: userdata.email,
                data: ""
            }));
            dispatch(profilesActions.setUpdateFriendlist());
        } else {
            dispatch(profilesActions.setMessage(res.message,"error"));
        }
        history.goBack();
    }

    const handleBlockUser = async (type) => {
        let res = await blockUser(params.id);
        if (res.status === 'ok') {
            dispatch(profilesActions.setMessage(Translate(`friends.blockedsuccess`),"ok"));
            dispatch(profilesActions.loadFriends(
                res.payload.friends ?? [],
                res.payload.invited ?? [],
                res.payload.pending ?? [],
            ));
            dispatch(rtcBufferActions.pushOutputBuffer({
                type: 'frienListUpdate',
                to: userdata.email,
                data: ""
            }));
            dispatch(profilesActions.setUpdateFriendlist());
        } else {
            dispatch(profilesActions.setMessage(res.message,"error"));
        }
        history.goBack();
    }

    const handleUnBlockUser = async (type) => {
        let res = await unblockUser(params.id);
        if (res.status === 'ok') {
            dispatch(profilesActions.setMessage(Translate(`friends.unblockedsuccess`),"ok"));
            dispatch(profilesActions.loadFriends(
                res.payload.friends ?? [],
                res.payload.invited ?? [],
                res.payload.pending ?? [],
            ));
        } else {
            dispatch(profilesActions.setMessage(res.message,"error"));
        }
        history.goBack();
    }
    
    const handleSendDenounce = async () => {
        let res = await denouceUser(params.id, denounceReason, denounceNote);
        if (res.status === 'ok') {
            dispatch(profilesActions.setMessage(Translate(`friends.denoucesuccess`),"ok"));
            dispatch(profilesActions.loadFriends(
                res.payload.friends ?? [],
                res.payload.invited ?? [],
                res.payload.pending ?? [],
            ));
            dispatch(rtcBufferActions.pushOutputBuffer({
                type: 'frienListUpdate',
                to: userdata.email,
                data: ""
            }));
            dispatch(profilesActions.setUpdateFriendlist());
        } else {
            dispatch(profilesActions.setMessage(res.message,"error"));
        }
        history.goBack();
    }

    const performAction = () => {
        switch(showConfirmAction) {
            case 'unfriend':
                handleCancelRequest('unfriend');
                break;
            case 'block':
                handleBlockUser();
                break;
            case 'denounce':
                setShowDenounceForm(true);
                break;
            default:
                break;
        }

        closeExtra();
    }

    const closeExtra = () => {
        setShowConfirmAction(false); 
        setShowExtraActions(false);
    }

    const fgColor = useMemo(()=>{
        if (!userdata || !userdata.color) {
            return "#fff";
        }

        return HEXtoBlackOrWhite(userdata.color) ?? '#fff';
    },[userdata]);

    const reasonsOptions = useMemo(()=>{
        return [...reasons].map(r => ({
            reason: r,
            rnd: Math.random()
        })).sort((a,b) => a.rnd > b.rnd ? -1 : 1).map(i => <option key={i.reason} value={i.reason}>{Translate(`denounces.${i.reason}`)}</option>);
    },[]);

    useEffect(()=>{
        let setState = true;

        (async () => {
            let data = await getUserProfile(params.id);

            if (setState && data.status === 'ok') {
                setUserdata(data.payload);
            }
        })();

        return () => {setState = false;}
    }, []);


    return <>
        <HeaderRow>
            <ButtonBack color="#aaa" onClick={handleBack} />
            <Title><T value="tables.titleUserProfile" /></Title>
            {showDenounceForm ? <>
                <Label><T value="denounces.reason" /></Label>
                <Select value={denounceReason} onChange={(e)=>setDenounceReason(e.target.value)}>
                    <option value="">{Translate()}</option>
                    {reasonsOptions}
                </Select>
                <Label><T value="denounces.note" /></Label>
                <Input style={{width:"150px",minWidth:"150px"}} value={denounceNote} onChange={(e)=>setDenounceNote(e.target.value)} />
                <Button color="#f33" onClick={handleSendDenounce}><T value="send" /></Button>
                <Button color="#888" onClick={()=>setShowDenounceForm(false)}><T value="cancel" /></Button>
            </> : <>
                {!showExtraActions && !showConfirmAction ? <>
                    { userdata && (userdata.relation === 0) ? 
                        <Button color="#0c0" onClick={handleAddAsFriend}><T value="userprofile.addAsFriend" /></Button>
                    : null }
                    { userdata && (userdata.relation === 1) ? 
                        <Button color="#28f" onClick={handleAcceptRequest}><T value="userprofile.acceptFriend" /></Button>
                    : null }
                    { userdata && (userdata.relation === 2) ? 
                        <Button color="#f77" onClick={()=>handleCancelRequest('remove')}><T value="userprofile.cancelRequest" /></Button>
                    : null }
                    { userdata ?
                        <ButtonIcon color="#be5cde" onClick={()=>setShowExtraActions(true)} icon="\F01D8" title={Translate("tables.more")} />
                    : null }
                </> : null }
                {showExtraActions && !showConfirmAction ? <>
                    {userdata.relation === 3 ?
                        <Button color="#B67121" onClick={() => setShowConfirmAction("unfriend")}><T value="userprofile.unfriend" /></Button>
                    : null }
                    {userdata.relation !== 4 ?
                        <Button color="#f33" onClick={() => setShowConfirmAction("block")}><T value="userprofile.block" /></Button>
                    :
                        <Button color="#0c0" onClick={handleUnBlockUser}><T value="userprofile.unblock" /></Button>
                    }
                    <Button color="#B0B0B0" onClick={() => setShowConfirmAction("denounce")}><T value="userprofile.denounce" /></Button>
                    <Button color="#06f" onClick={() => setShowExtraActions(false)}><T value="cancel" /></Button>
                </> : null }
                {showConfirmAction ? <>
                    <ConfirmMessage>{Translate(`userprofile.confirm-${showConfirmAction}`).replace('$1', userdata && userdata.name ? userdata.name : '')}</ConfirmMessage>
                    <Button color="#f33" onClick={() => performAction()}><T value="yes" /></Button>
                    <Button color="#0c0" onClick={() => closeExtra()}><T value="no" /></Button>
                </> : null }
            </>}
        </HeaderRow>
        
        { !userdata ? null : <UserProfilePage>
            <UserHeader>
                <UserLetter bgColor={userdata.color} fgColor={fgColor} >{String(userdata.name).substring(0,1).toUpperCase()}</UserLetter>
                <UserNamesGroup>
                    <UserName>{userdata.name}</UserName>
                    <UserLabel>{userdata.username}</UserLabel>
                </UserNamesGroup>
            </UserHeader>
            <UserInfo>
                <UserDataColumn>
                    <UserDataGeneralGroup>
                        <UserDataField>
                            <UserLabel><T value="userprofile.age" /></UserLabel>
                            <UserValue>{userdata.age ? <>
                                {userdata.age} <T value="userprofile.ageValue" />
                            </>: <None><T value="userprofile.notdefined" /></None>}</UserValue>
                        </UserDataField>
                        <UserDataField>
                            <UserLabel><T value="userprofile.gender" /></UserLabel>
                            <UserValue>{userdata.gender ? <>
                                <T value={`userprofile.gender${userdata.gender}`} />
                            </>: <None><T value="userprofile.notdefined" /></None>}</UserValue>
                        </UserDataField>
                        <UserDataField>
                            <UserLabel><T value="userprofile.city" /></UserLabel>
                            <UserValue>{userdata.city ? 
                                userdata.city+"/"+userdata.state 
                            : <None><T value="userprofile.notdefined" /></None>
                            }</UserValue>
                        </UserDataField>
                    </UserDataGeneralGroup>
                    {userdata.bio ? <UserDataGeneralGroup>
                        <UserDataField>
                            <UserLabel><T value="userprofile.bio" /></UserLabel>
                            <UserValue>{userdata.bio}</UserValue>
                        </UserDataField>
                    </UserDataGeneralGroup> : null }
                    <UserDataGeneralGroup>
                        <UserDataField>
                            <UserLabel></UserLabel>
                            <UserValue>{userdata.acceptVoice ? <Checked /> : <Unchecked />} <T value="userprofile.voice" /></UserValue>
                            <UserValue>{userdata.hasDesktop ? <Checked /> : <Unchecked />} <T value="userprofile.pc" /></UserValue>
                        </UserDataField>
                    </UserDataGeneralGroup>
                    <UserDataGeneralGroup>
                        <UserDataField className="compact">
                            <UserLabel></UserLabel>
                            <UserValue>{userdata.acceptVideo ? <Checked /> : <Unchecked />} <T value="userprofile.video" /></UserValue>
                            <UserValue>{userdata.hasTablet ? <Checked /> : <Unchecked />} <T value="userprofile.tablet" /></UserValue>
                        </UserDataField>
                    </UserDataGeneralGroup>
                    <UserDataGeneralGroup>
                        <UserDataField className="compact">
                            <UserLabel></UserLabel>
                            <UserValue>{userdata.acceptStream ? <Checked /> : <Unchecked />} <T value="userprofile.stream" /></UserValue>
                            <UserValue>{userdata.hasPhone ? <Checked /> : <Unchecked />} <T value="userprofile.phone" /></UserValue>
                        </UserDataField>
                    </UserDataGeneralGroup>
                    <UserDataGeneralGroup>
                        <UserDataField>
                            <UserLabel><T value="userprofile.contact" /></UserLabel>
                            <UserValue className="on"><ContactIcon className="hub" /> HubRPG</UserValue>
                            <UserValue className={userdata.whatsapp ? "on" : "off"}><ContactIcon className="whatsapp" /> WhatsApp</UserValue>
                        </UserDataField>
                    </UserDataGeneralGroup>
                    <UserDataGeneralGroup>
                        <UserDataField className="compact">
                            <UserLabel></UserLabel>
                            <UserValue className={userdata.facebook ? "on" : "off"}><ContactIcon className="facebook" /> Facebook</UserValue>
                            <UserValue className={userdata.instagram ? "on" : "off"}><ContactIcon className="instagram" /> Instagram</UserValue>
                        </UserDataField>
                    </UserDataGeneralGroup>
                    <UserDataGeneralGroup>
                        <UserDataField className="compact">
                            <UserLabel></UserLabel>
                            <UserValue className={userdata.telegram ? "on" : "off"}><ContactIcon className="telegram" /> Telegram</UserValue>
                            <UserValue className={userdata.twitter ? "on" : "off"}><ContactIcon className="twitter" /> Twitter</UserValue>
                        </UserDataField>
                    </UserDataGeneralGroup>
                    <UserDataGeneralGroup>
                        <UserDataField className="compact">
                            <UserLabel></UserLabel>
                            <UserValue className={userdata.discord ? "on" : "off"}><ContactIcon className="discord" /> Discord</UserValue>
                        </UserDataField>
                    </UserDataGeneralGroup>
                    <SectionTitle><T value="userprofile.availability" /></SectionTitle>
                    {userdata.availability ? userdata.availability.map((av,index) => <UserAvailable key={index}>
                        <span><T value={`dates-ddd.${av.weekday}`} /></span>, {Translate('userprofile.timeRange').replace('$1',ConvertToTimeDisplay(av.timestart)).replace('$2',ConvertToTimeDisplay(av.timeend))}, <T value={`frequencies.${av.frequency}`} />
                        {av.note ? 
                            <UserAvailableObs><T value="userprofile.note" />: {av.note}</UserAvailableObs>
                        : null}
                    </UserAvailable>) : null}
                </UserDataColumn>
                <UserDataColumn>
                    <UserTabs>
                        <UserTab onClick={()=>{setTabSelected("player")}} className={tabSelected === 'player' ? 'selected' : ''} ><T value="userprofile.asPlayer" /></UserTab>
                        <UserTab onClick={()=>{setTabSelected("gm")}} className={tabSelected === 'gm' ? 'selected' : ''} ><T value="userprofile.asGM" /></UserTab>
                    </UserTabs>
                    {tabSelected === 'player' ? <>
                        <UserDataGroupTags>
                            <UserDataField>
                                <UserLabelLine><T value="userprofile.acceptInvites" /></UserLabelLine>
                                <UserValue>{ userdata.player_acceptInvite ? <><Checked /><T value="yes" /></> : <><Unchecked /><T value="no" /></> }</UserValue>
                            </UserDataField>

                            <UserLabelLine className="spaced"><T value="userprofile.gameSystems" /></UserLabelLine>
                            <UserDataTagsRow>
                                {userdata.player_systems && userdata.player_systems.length > 0 ? 
                                    userdata.player_systems.map(s => <Tag color="#06f" key={s.id}>{s[Translate("lang")]}</Tag>)
                                : <UserDataNotValue><T value="userprofile.notSpecified" /></UserDataNotValue>}
                            </UserDataTagsRow>

                            <UserLabelLine className="spaced"><T value="userprofile.contentLikeable" /></UserLabelLine>
                            <UserDataTagsRow>
                                {userdata.player_contentLikable && userdata.player_contentLikable.length > 0 ? 
                                    userdata.player_contentLikable.map(c => <Tag color="#0c0" key={c.id}>{c[Translate("lang")]}</Tag>)
                                : <UserDataNotValue><T value="userprofile.notSpecified" /></UserDataNotValue>}
                            </UserDataTagsRow>
                            
                            <UserLabelLine className="spaced"><T value="userprofile.contentAvoidable" /></UserLabelLine>
                            <UserDataTagsRow>
                                {userdata.player_contentAvoidable && userdata.player_contentAvoidable.length > 0 ? 
                                    userdata.player_contentAvoidable.map(c => <Tag color="#f00" key={c.id}>{c[Translate("lang")]}</Tag>)
                                : <UserDataNotValue><T value="userprofile.notSpecified" /></UserDataNotValue>}
                            </UserDataTagsRow>
                            
                            <UserLabelLine className="spaced"><T value="userprofile.tools" /></UserLabelLine>
                            <UserDataTagsRow>
                                {userdata.player_tools && userdata.player_tools.length > 0 ? 
                                    userdata.player_tools.map(c => <Tag color="#fa0" key={c.id}>{c[Translate("lang")]}</Tag>)
                                : <UserDataNotValue><T value="userprofile.notSpecified" /></UserDataNotValue>}
                            </UserDataTagsRow>
                        </UserDataGroupTags>
                    </> : <>
                        <UserDataGroupTags>
                            <UserDataField>
                                <UserLabelLine><T value="userprofile.acceptInvites" /></UserLabelLine>
                                <UserValue>{ userdata.gm_acceptInvite ? <><Checked /><T value="yes" /></> : <><Unchecked /><T value="no" /></> }</UserValue>
                            </UserDataField>

                            <UserLabelLine className="spaced"><T value="userprofile.gameSystems" /></UserLabelLine>
                            <UserDataTagsRow>
                                {userdata.gm_systems && userdata.gm_systems.length > 0 ? 
                                    userdata.gm_systems.map(s => <Tag color="#06f" key={s.id}>{s[Translate("lang")]}</Tag>)
                                : <UserDataNotValue><T value="userprofile.notSpecified" /></UserDataNotValue>}
                            </UserDataTagsRow>

                            <UserLabelLine className="spaced"><T value="userprofile.contentLikeable" /></UserLabelLine>
                            <UserDataTagsRow>
                                {userdata.gm_contentLikable && userdata.gm_contentLikable.length > 0 ? 
                                    userdata.gm_contentLikable.map(c => <Tag color="#0c0" key={c.id}>{c[Translate("lang")]}</Tag>)
                                : <UserDataNotValue><T value="userprofile.notSpecified" /></UserDataNotValue>}
                            </UserDataTagsRow>
                            
                            <UserLabelLine className="spaced"><T value="userprofile.contentAvoidable" /></UserLabelLine>
                            <UserDataTagsRow>
                                {userdata.gm_contentAvoidable && userdata.gm_contentAvoidable.length > 0 ? 
                                    userdata.gm_contentAvoidable.map(c => <Tag color="#f00" key={c.id}>{c[Translate("lang")]}</Tag>)
                                : <UserDataNotValue><T value="userprofile.notSpecified" /></UserDataNotValue>}
                            </UserDataTagsRow>
                            
                            <UserLabelLine className="spaced"><T value="userprofile.tools" /></UserLabelLine>
                            <UserDataTagsRow>
                                {userdata.gm_tools && userdata.gm_tools.length > 0 ? 
                                    userdata.gm_tools.map(c => <Tag color="#fa0" key={c.id}>{c[Translate("lang")]}</Tag>)
                                : <UserDataNotValue><T value="userprofile.notSpecified" /></UserDataNotValue>}
                            </UserDataTagsRow>
                        </UserDataGroupTags>
                    </>}
                </UserDataColumn>
            </UserInfo>
        </UserProfilePage> }
    </>
};